import { Link, useNavigate, useParams } from "react-router";
import { showProduct } from "../../services/client/products/showProduct";
import useGetData from "../../hook/getData";
import { IconX } from "@tabler/icons-react";
import CompareFooter from "../../components/compare/compare";
import CompareProducts from "../../components/products/compareProducts";
import { CompareProvider } from "../../context/CompareContext";

const ComparePage = () => {
    const { slugs } = useParams();
    const navigate = useNavigate();
    const slugArray = slugs ? decodeURIComponent(slugs).split(",") : [];
    const { data: product_one } = useGetData(['detail', slugArray[0]], showProduct);
    const { data: product_second } = useGetData(['detail', slugArray[1]], showProduct);
    const { data: product_third } = useGetData(['detail', slugArray[2]], showProduct);
    const { data: product_fourth } = useGetData(['detail', slugArray[3]], showProduct);
    const handleRemoveProduct = (slugToRemove: string) => {
        const updatedSlugs = slugArray.filter((slug) => slug !== slugToRemove);
        if (updatedSlugs.length === 0) {
            navigate("/products");
        } else {
            navigate(`/product/compare/${encodeURIComponent(updatedSlugs.join(","))}`);
        }
    };
    return (
        <>
            <section className="container py-5">
                <div className="row">
                    {product_one ? (<>
                        <div className="col-md-3 col-6">
                            <div className="card card-body border-1 d-flex rounded rounded-4 position-sticky" style={{ top: '140px' }}>
                                <div className="d-flex justify-content-end">
                                    <button
                                        className="btn btn-link p-0"
                                        onClick={() => handleRemoveProduct(product_one?.product?.slug)}
                                        title="حذف محصول"
                                    >
                                        <IconX className="text-danger" size={20} />
                                    </button>
                                </div>
                                <div className="d-flex justify-content-center align-items-center">
                                    <Link to={`/products/detail/${product_one?.product?.slug}`} className="text-decoration-none">
                                        <img style={{ width: '100px', height: '100px' }} src={product_one?.product?.primary_image} alt="product" />
                                    </Link>
                                    <span className="text-dark w-100 text-line font-medium-lg mb-0">
                                        {product_one?.product?.name}
                                    </span>
                                </div>
                            </div>
                            <div className="row mt-3 py-3">
                                {product_one?.productAttributes?.map((item: any) => (
                                    <div className="col-12 mb-3">
                                        <div className="topic-detail-text-parent w-100 p-3">
                                            <p className="topic-detail-text mb-0">
                                                {item.attribute.name}
                                            </p>
                                            <p className="topic-detail-text-child text-split fw-bold mb-0">
                                                {item.value}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>) : null}
                    {product_second ? (<>
                        <div className="col-md-3 col-6">
                            <div className="card card-body border-1 d-flex rounded rounded-4 position-sticky" style={{ top: '140px' }}>
                                <div className="d-flex justify-content-end">
                                    <button
                                        className="btn btn-link p-0"
                                        onClick={() => handleRemoveProduct(product_second?.product?.slug)}
                                        title="حذف محصول"
                                    >
                                        <IconX className="text-danger" size={20} />
                                    </button>
                                </div>
                                <div className="d-flex justify-content-center align-items-center">
                                    <Link to={`/products/detail/${product_second?.product?.slug}`} className="text-decoration-none">
                                        <img style={{ width: '100px', height: '100px' }} src={product_second?.product?.primary_image} alt="product" />
                                    </Link>
                                    <span className="text-dark w-100 text-line font-medium-lg mb-0">
                                        {product_second?.product?.name}
                                    </span>
                                </div>
                            </div>
                            <div className="row mt-3 py-3">
                                {product_second?.productAttributes?.map((item: any) => (
                                    <div className="col-12 mb-3">
                                        <div className="topic-detail-text-parent w-100 p-3">
                                            <p className="topic-detail-text mb-0">
                                                {item.attribute.name}
                                            </p>
                                            <p className="topic-detail-text-child text-split fw-bold mb-0">
                                                {item.value}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>) : null}
                    {product_third ? (<>
                        <div className="col-md-3 col-6 d-md-inline-block d-none">
                            <div className="card card-body border-1 d-flex rounded rounded-4 position-sticky" style={{ top: '140px' }}>
                                <div className="d-flex justify-content-end">
                                    <button
                                        className="btn btn-link p-0"
                                        onClick={() => handleRemoveProduct(product_third?.product?.slug)}
                                        title="حذف محصول"
                                    >
                                        <IconX className="text-danger" size={20} />
                                    </button>
                                </div>
                                <div className="d-flex justify-content-center align-items-center">
                                    <Link to={`/products/detail/${product_third?.product?.slug}`} className="text-decoration-none">
                                        <img style={{ width: '100px', height: '100px' }} src={product_third?.product?.primary_image} alt="product" />
                                    </Link>
                                    <span className="text-dark w-100 text-line font-medium-lg mb-0">
                                        {product_third?.product?.name}
                                    </span>
                                </div>
                            </div>
                            <div className="row mt-3 py-3">
                                {product_third?.productAttributes?.map((item: any) => (
                                    <div className="col-12 mb-3">
                                        <div className="topic-detail-text-parent w-100 p-3">
                                            <p className="topic-detail-text mb-0">
                                                {item.attribute.name}
                                            </p>
                                            <p className="topic-detail-text-child text-split fw-bold mb-0">
                                                {item.value}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>) : null}
                    {product_fourth ? (<>
                        <div className="col-md-3 col-6 d-md-inline-block d-none">
                            <div className="card card-body border-1 d-flex rounded rounded-4 position-sticky" style={{ top: '140px' }}>
                                <div className="d-flex justify-content-end">
                                    <button
                                        className="btn btn-link p-0"
                                        onClick={() => handleRemoveProduct(product_fourth?.product?.slug)}
                                        title="حذف محصول"
                                    >
                                        <IconX className="text-danger" size={20} />
                                    </button>
                                </div>
                                <div className="d-flex justify-content-center align-items-center">
                                    <Link to={`/products/detail/${product_fourth?.product?.slug}`} className="text-decoration-none">
                                        <img style={{ width: '100px', height: '100px' }} src={product_fourth?.product?.primary_image} alt="product" />
                                    </Link>
                                    <span className="text-dark w-100 text-line font-medium-lg mb-0">
                                        {product_fourth?.product?.name}
                                    </span>
                                </div>
                            </div>
                            <div className="row mt-3 py-3">
                                {product_fourth?.productAttributes?.map((item: any) => (
                                    <div className="col-12 mb-3">
                                        <div className="topic-detail-text-parent w-100 p-3">
                                            <p className="topic-detail-text mb-0">
                                                {item.attribute.name}
                                            </p>
                                            <p className="topic-detail-text-child text-split fw-bold mb-0">
                                                {item.value}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>) : (
                        <>
                            <div className="col-md-3 col-6 d-md-inline-block d-none">
                                <div data-bs-toggle="modal" data-bs-target="#compare-modal" className="card card-body border-1 d-flex rounded rounded-4 position-sticky" style={{ top: '140px' }}>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <img style={{ height: '100px' }} src="https://zitro.ir/assets/images/products/search.svg" className="img-fluid" alt="img" />
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </section>
            <CompareProvider mainProductSlug={slugArray[0]}>
                <div className="modal fade" id="compare-modal">
                    <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
                        <div className="modal-content px-3">
                            <div className="modal-header justify-content-between">
                                <h6 className="mb-0 text-site fw-bold">مقایسه کالا</h6>
                                <IconX data-bs-dismiss="modal" />
                            </div>
                            <div className="modal-body">
                                {product_one?.sameProducts ? (
                                    <div className="row gy-4">
                                        {product_one?.sameProducts?.map((product: any) => (
                                            <div className="col-md-3" key={product.id + "products"}>
                                                <CompareProducts
                                                    slug={product.slug}
                                                    id={product.id}
                                                    name={product.name}
                                                    primary_image={product.primary_image}
                                                    quantity_check={product.quantity_check}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                ) : null}
                            </div>
                            <div className="modal-footer border-0">
                                <button hidden className="d-none" id="close-compare" data-bs-dismiss="modal"></button>
                                <CompareFooter />
                            </div>
                        </div>
                    </div>
                </div>
            </CompareProvider>
        </>
    )
}

export default ComparePage;